import { Link } from "react-router-dom";
import { useSession } from "@jkast90/kast-common/auth";
import MaterialIcon from "@common/components/MaterialIcon";
import { useOnline } from "@common/online";
import { here } from "../../desktop/desktop";
import { signIn } from "../session";

// In both headers (the site's and the player's), so it is where being
// offline shows on every page. Signing out is on the profile page. Sign-in is a page on another origin, which
// offline would leave an app on the home screen stuck on an error page.
function OfflineChip({ signedIn }: { signedIn: boolean }) {
  return (
    <span
      className="offline-chip"
      role="status"
      data-tip={`You're offline. Games and saves in ${here} still work${signedIn ? "; cloud saves go up when you're back online" : "; signing in needs a connection"}.`}
    >
      Offline
    </span>
  );
}

export default function AuthMenu() {
  const { status, user } = useSession();
  const online = useOnline();

  // Only while a stored session that had expired is refreshed.
  if (status === "loading") return <span className="muted">Checking sign-in…</span>;

  if (status === "signedIn") {
    return (
      <div className="auth">
        {!online && <OfflineChip signedIn />}
        <Link
          to="/profile"
          className="btn icon-btn auth-me"
          aria-label="Your profile"
          data-tip={`${user?.name || "You"} · your profile`}
        >
          <MaterialIcon name="account_circle" />
        </Link>
      </div>
    );
  }

  if (!online) {
    return (
      <div className="auth">
        <OfflineChip signedIn={false} />
      </div>
    );
  }

  return (
    <button type="button" className="btn" onClick={signIn}>
      Sign in
    </button>
  );
}
